import { defineMessages } from "react-intl";
import { DefineMsg } from "types/types";
import { countries } from "./countries";

export const countryMsg: DefineMsg = defineMessages(countries);
